import { render } from "./UpdateRolePage.vue?vue&type=template&id=37dc4ecc&ts=true"
import script from "./UpdateRolePage.vue?vue&type=script&lang=ts"
export * from "./UpdateRolePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Roles/UpdateRolePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37dc4ecc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37dc4ecc', __exports__)) {
    api.reload('37dc4ecc', __exports__)
  }
  
  module.hot.accept("./UpdateRolePage.vue?vue&type=template&id=37dc4ecc&ts=true", () => {
    api.rerender('37dc4ecc', render)
  })

}


export default __exports__